import { requestSuggest } from '../../dataSource/suggest/suggest.requests'
import SuggestError from '../../domain/suggest/SuggestError'
import { selectMapBbox } from '../map/map.selectors'
import { selectLocale } from '../navigation/navigation.selectors'
import parse from './suggest.dataParser'
import { loadSuggestError, loadSuggestResponse, resetSuggestData, setSuggestInputValue } from './suggestSlice'

const isResponseFromLastRequest = (suggest, requestTime) => {
  return suggest.lastRequestTime < requestTime
}

export const suggest =
  ({ terms, suggestFilterType = 'all' }) =>
  (dispatch, getState) => {
    if (!terms) {
      dispatch(resetSuggestData())
      return Promise.resolve()
    }

    dispatch(setSuggestInputValue(terms))

    const requestTime = Date.now()
    const locale = selectLocale(getState())
    const bbox = selectMapBbox(getState())
    return requestSuggest(bbox, locale, { terms, suggestFilterType })
      .then(response => {
        const { data } = response

        if (!data?.suggests) {
          throw new SuggestError()
        }

        const { suggest } = getState()

        if (isResponseFromLastRequest(suggest, requestTime)) {
          dispatch(loadSuggestResponse({ data: parse(data), requestTime }))
        }
      })
      .catch(error => {
        const { suggest } = getState()
        if (isResponseFromLastRequest(suggest, requestTime)) {
          dispatch(loadSuggestError({ error, requestTime }))
        }
      })
  }
